import { memo } from 'react';
import { CheckboxCheckIcon } from 'client/components/common/icons';

type Props = {
  label: string;
  checked: boolean;
  onClick: () => void;
  checkIconWidth?: number;
  checkIconHeight?: number;
  labelFontSize?: number;
};

export const Checkbox = memo(({ label, checked, onClick, checkIconWidth, checkIconHeight, labelFontSize }: Props) => {
  return (
    <div className="inline-flex items-center" onClick={onClick}>
      <div
        className={`bg-white box-border rounded mr-2 ${checkIconWidth ? `w-[${checkIconWidth}px]` : 'w-5'} ${
          checkIconHeight ? `h-[${checkIconHeight}px]` : 'h-5'
        } ${!checked && 'border border-solid border-bank-gray'}`}
      >
        {checked && (
          <CheckboxCheckIcon
            width={checkIconWidth ?? 20}
            height={checkIconHeight ?? 20}
            dataTestId={`recruitments-search-modal-checkbox-icon-${label}`}
          />
        )}
      </div>
      <div className={`text-black text-center font-normal ${labelFontSize ? `text-[${labelFontSize}px]` : 'text-sm'}`}>
        {label}
      </div>
    </div>
  );
});
